import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import {
  DateRangePicker,
  GuestPicker,
  HotelLocationAutocomplete,
} from "@tenant/hotels";
import { useHotelAvailabilitySearch } from "@tenant/hotels";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  Icon,
  DialogClose,
  InputContainer,
} from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelAvailabilitySearch.module.scss";

const COMPONENT_KEY = CoreHotelsComponent.HotelAvailabilitySearch;

export type HotelAvailabilitySearchProps = PlatformComponentProps;
export const HotelAvailabilitySearch = ({
  children,
  className,
}: HotelAvailabilitySearchProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers, text } = useHotelAvailabilitySearch();

  const search = (activeSearch: boolean) => (
    <div className={cn("search")}>
      <HotelLocationAutocomplete
        label={text.locationLabel}
        value={context.place}
        defaultValue={context.place}
        onChange={(val) => handlers.handlePlaceChange(val, activeSearch)}
        id={"hotel-location-autocomplete"}
      />
      <DateRangePicker
        startDate={context.dateRange?.from}
        endDate={context.dateRange?.until}
        onStartDateChangeHandler={(date) => {
          handlers.handleDateRangeFromChange(date);
        }}
        onEndDateChangeHandler={(date) => {
          handlers.handleDateRangeUntilChange(date);
        }}
        onClose={() => handlers.handleDateRangeClose(activeSearch)}
      />
      <GuestPicker
        onGuestSelectionHandler={(guests, rooms) => {
          handlers.handleGuestsChange(guests, rooms, activeSearch);
        }}
        className={cn("guest-picker")}
        guests={context.guests}
        rooms={context.rooms}
      />
    </div>
  );
  return (
    <div className={clsx(block, className)}>
      <div className={cn("desktop-search")}>{search(true)}</div>
      <Dialog modal={false}>
        <DialogTrigger className={cn("search-button")}>
          <InputContainer
            id="hotel-availability-search"
            className={cn("input-container")}
          >
            <div className={cn("input-container-content")}>
              <div className={cn("icon")}>
                <Icon
                  iconName={IconNameEnum.search}
                  className={cn("icon-search")}
                />
              </div>
              <div className={cn("content")}>
                <div className={cn("search-button-label")}>
                  {text.locationData}
                </div>
                <div className={cn("search-button-value")}>
                  {text.searchSummary}
                </div>
              </div>
            </div>
          </InputContainer>
        </DialogTrigger>
        <DialogContent
          fullScreen
          bottomFixedContent={
            <DialogClose asChild>
              <button
                className={cn("submit-search-button")}
                onClick={handlers.handleSearchClick}
              >
                {text.search}
              </button>
            </DialogClose>
          }
        >
          {search(false)}
        </DialogContent>
      </Dialog>
      {children}
    </div>
  );
};
